// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { TermsApi } from '../types/terms.types';
import { termsHttpApi } from './terms.api';
import { termsMockApi } from './terms.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const termsApi: TermsApi = useMock ? termsMockApi : termsHttpApi;
